import { QUERY_KEYS } from 'api/query-keys';
import { useMutation, useQueryClient } from 'react-query';
import { companyService } from 'ogp/services';
import { UpdateCompanyThemePayload } from 'ogp/services/company-service.types';

export const useUpdateCompanyTheme = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload: UpdateCompanyThemePayload) => {
      return await companyService.updateCompanyTheme(payload);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: QUERY_KEYS.ownCompanyTheme() });
      },
    }
  );
};
